"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
const TileLine = _ref => {
  let {
    isHighlighted = false
  } = _ref;
  const TileLineStyle = _styled.default.div({
    background: isHighlighted ? '#001E62' : '#CCCCCC',
    height: '2px',
    margin: '4px',
    width: '40px'
  });
  return /*#__PURE__*/_react.default.createElement(TileLineStyle, null);
};
var _default = exports.default = TileLine;